import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter } from 'rxjs';
import * as EventsActions from '@assist/shared/data';
import { tap } from 'rxjs/operators';
import { NotificationService } from './notification.service';
import { Router } from '@angular/router';

@Injectable()
export class NotificationsEffects {
  private actions$ = inject(Actions);
  private router = inject(Router);
  private notificationService = inject(NotificationService);
  loadEventsWhenUserHasChanged$$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(EventsActions.eventCreated),
        filter((x) => x.roomEmails != null && x.suppressCreatedNotification !== true),
        tap((action) => {
          this.notificationService.reserved(action.id, action.subject, action.roomEmails[0]);
          if (!action.skipReservationNavigation && this.router.routerState.snapshot.url.includes('reservations')) {
            this.router.navigate(['/reservations', 'reserve']);
          }
        })
      );
    },
    {
      dispatch: false,
    }
  );
}
